import { MagicLinkAuthenticationError } from '@hooks/auth/useMagicLink';

export const getSafeAuthRedirect = (redirectUrl?: string) => {
  if (redirectUrl === '/dashboard') {
    return redirectUrl;
  }

  return '/dashboard';
};

export type MagicLinkAuthErrorKey = 'auth.verify.linkExpired' | 'auth.verify.linkInvalid';

export const getMagicLinkAuthErrorKey = (error?: unknown): MagicLinkAuthErrorKey => {
  if (error instanceof MagicLinkAuthenticationError && error.code === 'link_expired') {
    return 'auth.verify.linkExpired';
  }

  return 'auth.verify.linkInvalid';
};
